module.exports = __webpack_public_path__ + "static/media/Grill.cae81bd0.svg";